sharpen-course-description sharpen-card {
  display: flex;
  gap: 1em;
  align-items: center;

  .sharpen-icon {
    color: var(--color-orange);
    font-size: var(--font-size-3xl);
  }
  
  div { flex: 1; }
  
  li::marker { color: var(--color-orange); }
}